	export enum PureToneStimulusMethodEnum {
		Insert = 1,
		VRA = 2,
		Play = 3,
		Headphones = 4
	}
